import { getFeatureToggle } from 'app/components/auth/Feature'

export const TANSTACK_QUERY_FETCH_TOGGLE = `tanstack-query-fetch`

export type GetRequestMode = `legacy` | `query-cache`

type RunGetRequestArgs<T> = {
  cached: () => Promise<T>
  legacy: () => Promise<T>
  mode?: GetRequestMode
}

export async function getGetRequestMode(): Promise<GetRequestMode> {
  const tanstackQueryFetch = await getFeatureToggle(TANSTACK_QUERY_FETCH_TOGGLE)
  return tanstackQueryFetch ? `query-cache` : `legacy`
}

export async function runGetRequest<T>({ cached, legacy, mode }: RunGetRequestArgs<T>): Promise<T> {
  const resolvedMode = mode ?? (await getGetRequestMode())

  if (resolvedMode === `legacy`) {
    return legacy()
  }

  return cached()
}

export function getRequestQueryKey(url: string) {
  return [`request`, url] as const
}
